var impressum = "Impressum";
var privacy = "Datenschutz u. Rechtsgrundlagen";
var recallInfo = "Rückruf-Info";
var signOut = "Abmelden";
var de_de = {
	impressum: impressum,
	privacy: privacy,
	recallInfo: recallInfo,
	signOut: signOut
};

export { de_de as default, impressum, privacy, recallInfo, signOut };
